import React from "react";
import EditorDashboardWrapper from "../../../layout/wrapper/EditorDashboardWrapper";
import styles from "../../../styles/pages/user/memberpartner/partner-message.module.scss";
import {
  Box,
  List,
  ListItem,
  Select,
  MenuItem,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Popover,
} from "@mui/material";
import view_icon from "../../../public/assets/images/eye_icon.svg";
import key_icon from "../../../public/assets/images/lock_icon.svg";
import LeftArrow from "../../../ui/Icons/LeftArrow";
import RightArrow from "../../../ui/Icons/RightArrow";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useState } from "react";
import MessageIcon from "../../../ui/Icons/MessageIcon";
import { Link, useLocation } from "react-router-dom";
import MemberPartnerDashboard from "./MemberPartnerDashboard";
import MemberPartnerDashboardWrapper from "../../../layout/wrapper/MemberPartnerDashboardWrapper";
import {
  getMonthQueryRange,
  getMonthRange,
  getPagination,
  getUtcDate,
  getUtcTime,
  getYearRange,
} from "../../../lib/functions/utils.lib";
import useFetch from "../../../hooks/api/useFetch";
import { useEffect } from "react";
import { Stack } from "@mui/system";
import ApiLoader from "../../../components/Loaders/ApiLoader";

const SelectItem = [
  {
    name: "Message Status",
  },
  {
    name: "Option1",
  },
  {
    name: "Option2",
  },
];

const tableHead = [
  {
    name: "VSID",
  },
  {
    name: "Sender",
  },
  {
    name: "Recipient",
  },
  {
    name: "Message",
  },
  {
    name: "Creation Date",
  },
  {
    name: "Status",
  },
  {
    name: "View",
  },
];

const tableBody = [
  {
    id: "#15465",
    name: "ViralSnare Admin",
    designation: "Admin",
    recipentName: "Me, Myself & I",
    recipentDesignation: "Partner",
    message:
      "Hi there, how are you doing? I was trying to reest my password but it kept showing me an error message and I am not su...",
    date: (
      <>
        January 16, 2023 <br /> at 07:53 AM UTC
      </>
    ),
    statusQuery: false,
  },
  {
    id: "#6589",
    name: "Me, Myself & I",
    designation: "Partner",
    recipentName: "Recipient Name",
    recipentDesignation: "Manager",
    message:
      "I am curious on when I’ll be paid? Could you please let me know? Thanks in advance!",
    date: (
      <>
        January 14, 2023 <br /> at 10:22 PM UTC
      </>
    ),
    statusQuery: true,
  },
  {
    id: "#15876",
    name: "Me, Myself & I",
    designation: "Partner",
    recipentName: "Recipient Name",
    recipentDesignation: "QC Agent",
    message:
      "Hey, i wanted to message you to let you know that we got the original file and I have added it to the submission. Thanks!",
    date: (
      <>
        January 01, 2023 <br /> at 07:22 PM UTC
      </>
    ),
    statusQuery: true,
  },
];

const tableHeadArchieve = [
  {
    name: "VSID",
  },
  {
    name: "Sender",
  },
  {
    name: "Recipient",
  },
  {
    name: "Message",
  },
  {
    name: "Creation Date",
  },
  {
    name: "Resolved On",
  },
  {
    name: "View",
  },
];

const tableBodyArchieve = [
  {
    id: "15465",
    name: "ViralSnare Admin",
    designation: "Admin",
    recipentName: "Me, Myself & I",
    recipentDesignation: "Partner",
    message:
      "Hi there, how are you doing? I was trying to reest my password but it kept showing me an error message and I am not su...",
    date: (
      <>
        January 16, 2023 <br /> at 07:53 AM UTC
      </>
    ),
    resolveDate: (
      <>
        January 16, 2023 <br /> at 07:53 AM UTC
      </>
    ),
  },

  {
    id: "6589",
    name: "Me, Myself & I",
    designation: "Partner",
    recipentName: "Recipient Name",
    recipentDesignation: "Manager",
    message:
      "I am curious on when I’ll be paid? Could you please let me know? Thanks in advance!",
    date: (
      <>
        January 14, 2023 <br /> at 10:22 PM UTC
      </>
    ),
    resolveDate: (
      <>
        January 16, 2023 <br /> at 07:53 AM UTC
      </>
    ),
  },

  {
    id: "15876",
    name: "Me, Myself & I",
    designation: "Partner",
    recipentName: "Recipient Name",
    recipentDesignation: "QC Agent",
    message:
      "Hey, i wanted to message you to let you know that we got the original file and I have added it to the submission. Thanks!",
    date: (
      <>
        January 01, 2023 <br /> at 07:22 PM UTC
      </>
    ),
    resolveDate: (
      <>
        January 16, 2023 <br /> at 07:53 AM UTC
      </>
    ),
  },
];

function PartnerMessage() {
  const [age, setAge] = React.useState("0");
  const [month, setMonth] = React.useState("");
  const [year, setYear] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState(1);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const text = queryParams.get("text");
  const [status, setStatus] = React.useState(
    text?.length > 0
      ? text === "Need to replay"
        ? "asd"
        : text === "Pending"
        ? "2"
        : ""
      : ""
  );

  const handleChange1 = (event) => {
    setStatus(event.target.value);
  };

  const handleChange2 = (event) => {
    setMonth(event.target.value);
  };

  const handleChange3 = (event) => {
    setYear(event.target.value);
  };

  const [archive, setArchive] = useState(false);

  const handleClicked = () => {
    // ArchiveUpdate(!Archive);
    setArchive((prev) => !prev);
  };

  //   message details
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const {
    data: messages,
    isLoading,
    isSuccess,
    isError,
    isFetching,
  } = useFetch(
    ["messages", status, archive, month, year, currentPage],
    `inquiries?type=message${
      status.toString()
        ? `&${status == 2 ? "need_your_reply=yes" : "status=" + status}`
        : ""
    }
            &archive=${archive ? 1 : 0}
            ${
              month && year
                ? `&from=${
                    getMonthQueryRange(month, year, "obj").from_date
                  }&to=${getMonthQueryRange(month, year, "obj").to_date}`
                : ""
            }&page=${currentPage}`
  );

  const [paginationData, setPaginationData] = React.useState({
    hasNextPage: false,
    hasPrevPage: false,
  });

  const handleNextPage = () => {
    if (paginationData.hasNextPage) setCurrentPage((prev) => prev + 1);
  };
  const handlePrevPage = () => {
    if (paginationData.hasPrevPage) setCurrentPage((prev) => prev - 1);
  };

  useEffect(
    () => {
      if (text?.length > 0) {
        return;
      }

      if (text === "need to replay") {
        setStatus("asd");
        isFetching();
      }
      if (text === "pending") {
        setStatus("2");
        isFetching();
      }
    },
    [text && text],
    status
  );

  const getStatus = (inquiry) => {
    if (!inquiry?.status) {
      if (inquiry?.initiated?.name === inquiry?.last_message?.sender?.name)
        return {
          name: "Need your reply",
          class: `${styles.quer_sec_btns}`,
        };
      return {
        name: "Pending",
        class: `${styles.quer_sec_btns} ${styles.pending}`,
      };
    }
    return {
      name: "Resolved",
      class: `${styles.quer_sec_btns} ${styles.resolved}`,
    };
  };

  useEffect(() => {
    const { hasNextPage, hasPrevPage } = getPagination(
      messages?.data?.meta?.current_page,
      messages?.data?.meta?.last_page
    );
    setPaginationData({
      hasNextPage: hasNextPage,
      hasPrevPage: hasPrevPage,
    });
  }, [messages]);
  //   message details

  console.log("messagesData", messages?.data?.data);

  return (
    <>
      <MemberPartnerDashboardWrapper>
        <>
          <ApiLoader
            loading={
              isLoading &&
              !(
                messages?.data.data.length ||
                status.toString() ||
                month ||
                year
              )
            }
          />{" "}
          {isLoading &&
          !(
            messages?.data.data.length ||
            status.toString() ||
            month ||
            year
          ) ? (
            ""
          ) : (isSuccess && messages?.data.data.length) ||
            status.toString() ||
            month ||
            year ? (
            <Box className={styles.message_status_wrapper}>
              <Box className={styles.message_status_topwrp}>
                <List>
                  <ListItem>
                    <Box className={styles.status_messages_select}>
                      <Select
                        value={status}
                        onChange={handleChange1}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                              borderRadius: "7px",
                              marginTop: "5px",

                              "& .MuiMenuItem-root": {
                                padding: 0,
                                fontSize: "11px",
                                fontWeight: "500",
                                color: "#525050",
                                lineHeight: "1",
                                "&:hover": {
                                  backgroundColor: "#ffffff",
                                  color: "#111ae9",
                                },
                                "&:not(:last-child)": {
                                  marginBottom: "10px",
                                },
                                "&:first-child": {
                                  display: "none",
                                },
                              },
                              "& .Mui-selected": {
                                background: "#fff !important",
                              },

                              "& .MuiList-root": {
                                padding: "20px 14px",
                                minWidth: "134px",
                              },
                            },
                          },
                        }}
                      >
                        <MenuItem value="">Message Status</MenuItem>
                        <MenuItem value="asd">Need your reply</MenuItem>
                        <MenuItem value="2">Pending</MenuItem>
                        <MenuItem value="1">Resolved</MenuItem>
                      </Select>
                    </Box>
                  </ListItem>

                  <ListItem>
                    <Box className={styles.creation_date}>
                      <Button onClick={handleClick}>
                        Creation Date
                        <i>
                          <img src={key_icon} alt="" />
                        </i>
                      </Button>
                      <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        PaperProps={{
                          sx: {
                            boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                            borderRadius: "7px",
                            marginTop: "5px",
                            padding: "24px",
                            maxWidth: "254px",
                            width: "100%",
                            "& .MuiTypography-caption": {
                              fontWeight: "500",
                              fontSize: "13px",
                              color: "#494949",
                              marginBottom: "8px",
                              display: "block",
                            },
                          },
                        }}
                      >
                        <Typography variant="caption">Created in</Typography>
                        <Stack
                          direction="row"
                          alignItems="center"
                          flexWrap="wrap"
                          className={styles.selectDate}
                        >
                          <Select
                            value={month}
                            onChange={handleChange2}
                            displayEmpty
                            inputProps={{
                              "aria-label": "Without label",
                            }}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  boxShadow:
                                    "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                                  borderRadius: "7px",
                                  marginTop: "5px",

                                  "& .MuiMenuItem-root": {
                                    padding: 0,
                                    fontSize: "11px",
                                    fontWeight: "500",
                                    color: "#525050",
                                    lineHeight: "1",
                                    "&:hover": {
                                      backgroundColor: "#ffffff",
                                      color: "#111ae9",
                                    },
                                    "&:not(:last-child)": {
                                      marginBottom: "10px",
                                    },
                                    "&:first-child": {
                                      display: "none",
                                    },
                                  },
                                  "& .Mui-selected": {
                                    background: "#fff !important",
                                  },

                                  "& .MuiList-root": {
                                    padding: "20px 14px",
                                  },
                                },
                              },
                            }}
                          >
                            <MenuItem value="">Month</MenuItem>
                            {getMonthRange().map((item, index) => (
                              <MenuItem value={item?.value} key={index}>
                                {item?.month}
                              </MenuItem>
                            ))}
                          </Select>
                          <Select
                            value={year}
                            onChange={handleChange3}
                            displayEmpty
                            inputProps={{
                              "aria-label": "Without label",
                            }}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  boxShadow:
                                    "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                                  borderRadius: "7px",
                                  marginTop: "5px",

                                  "& .MuiMenuItem-root": {
                                    padding: 0,
                                    fontSize: "11px",
                                    fontWeight: "500",
                                    color: "#525050",
                                    lineHeight: "1",
                                    "&:hover": {
                                      backgroundColor: "#ffffff",
                                      color: "#111ae9",
                                    },
                                    "&:not(:last-child)": {
                                      marginBottom: "10px",
                                    },
                                    "&:first-child": {
                                      display: "none",
                                    },
                                  },
                                  "& .Mui-selected": {
                                    background: "#fff !important",
                                  },

                                  "& .MuiList-root": {
                                    padding: "20px 14px",
                                  },
                                },
                              },
                            }}
                          >
                            <MenuItem value="">Year</MenuItem>
                            {getYearRange().map((item, index) => (
                              <MenuItem value={item.value} key={index}>
                                {item.year}
                              </MenuItem>
                            ))}
                          </Select>
                        </Stack>
                      </Popover>
                    </Box>
                  </ListItem>

                  <ListItem>
                    <Button
                      style={{
                        backgroundColor: archive ? "blue" : "",
                      }}
                      className={
                        archive
                          ? `${styles.archievr_btns} ${styles.active}`
                          : `${styles.archievr_btns}`
                      }
                      onClick={handleClicked}
                    >
                      Archive
                    </Button>
                  </ListItem>
                </List>
              </Box>

              <Box className={styles.message_status_btmwrp}>
                {archive ? (
                  <PerfectScrollbar className={styles.perfect_scroll_message}>
                    <TableContainer>
                      <Table
                        aria-label="customized table"
                        className={styles.new_table_customised}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell component="th">VSID</TableCell>
                            <TableCell component="th">Sender</TableCell>
                            <TableCell component="th">Recipient</TableCell>
                            <TableCell component="th">Message</TableCell>
                            <TableCell component="th">Creation Date</TableCell>
                            <TableCell component="th">
                              {archive ? "Resolved On" : "Status"}
                            </TableCell>
                            <TableCell component="th">View</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {isSuccess &&
                            messages?.data?.data.map((item, index) => {
                              if (
                                status === 0 &&
                                item?.initiated?.name ===
                                  item?.last_message?.sender?.name
                              ) {
                                return "";
                              } else if (
                                status === 2 &&
                                item?.initiated?.name !==
                                  item?.last_message?.sender?.name
                              ) {
                                return "";
                              } else if (status === 2 && item?.status) {
                                return "";
                              }
                              return (
                                <>
                                  {" "}
                                  <TableRow key={index}>
                                    <TableCell
                                      component="td"
                                      scope="row"
                                      className={styles.id_table}
                                    >
                                      <Box className={styles.table_id_captns}>
                                        <Link to="">{item?.video?.id}</Link>

                                        {/* <Typography
                                          variant="caption"
                                          className={styles.tooltips_spn}
                                        >
                                          Open Video Page
                                        </Typography> */}
                                      </Box>
                                    </TableCell>

                                    <TableCell
                                      component="td"
                                      scope="row"
                                      className={styles.sender_table}
                                    >
                                      {item?.initiated?.name}
                                      <Typography
                                        variant="caption"
                                        className={styles.design_profile}
                                      >
                                        {item?.initiated?.role?.display_name}
                                      </Typography>
                                    </TableCell>

                                    <TableCell
                                      component="td"
                                      scope="row"
                                      className={styles.recipant_nm_table}
                                    >
                                      {item?.recipent?.name}
                                      <Typography
                                        variant="caption"
                                        className={styles.design_profile}
                                      >
                                        {item?.recipent?.role?.display_name}
                                      </Typography>
                                    </TableCell>

                                    <TableCell
                                      component="td"
                                      scope="row"
                                      className={styles.messages_table}
                                    >
                                      {item?.message?.length > 20
                                        ? item?.message?.slice(0, 110) + "..."
                                        : item?.message}
                                    </TableCell>

                                    <TableCell
                                      component="td"
                                      scope="row"
                                      className={styles.creation_date_table}
                                    >
                                      {getUtcDate(item?.created)} <br />{" "}
                                      {getUtcTime(item?.created)}
                                    </TableCell>

                                    <TableCell
                                      component="td"
                                      scope="row"
                                      className={styles.resolve_table_date}
                                    >
                                      {archive ? (
                                        <TableCell
                                          component="td"
                                          scope="row"
                                          className={styles.resolve_table_date}
                                        >
                                          {getUtcDate(item?.resolved_at)} <br />{" "}
                                          {getUtcTime(item?.resolved_at)}
                                        </TableCell>
                                      ) : (
                                        <Typography
                                          variant="caption"
                                          className={getStatus(item).class}
                                        >
                                          {getStatus(item).name}
                                        </Typography>
                                      )}
                                    </TableCell>

                                    <TableCell
                                      component="td"
                                      scope="row"
                                      className={styles.view_sec_table}
                                    >
                                      <Box className={styles.eye_icon_tooltip}>
                                        <Button className={styles.eye_icon_sec}>
                                          <Link
                                            to={`/member-partner-dashboard/message/video/${item?.id}`}
                                          >
                                            {" "}
                                            <img src={view_icon} alt="" />
                                          </Link>
                                        </Button>
                                        <Typography
                                          variant="caption"
                                          className={styles.tooltips_spn2}
                                        >
                                          Open Message
                                        </Typography>
                                      </Box>
                                    </TableCell>
                                  </TableRow>
                                </>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </PerfectScrollbar>
                ) : (
                  <>
                    {" "}
                    <PerfectScrollbar className={styles.perfect_scroll_message}>
                      <TableContainer>
                        <Table
                          aria-label="customized table"
                          className={styles.new_table_customised}
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell component="th">VSID</TableCell>
                              <TableCell component="th">Sender</TableCell>
                              <TableCell component="th">Recipient</TableCell>
                              <TableCell component="th">Message</TableCell>
                              <TableCell component="th">
                                Creation Date
                              </TableCell>
                              <TableCell component="th">
                                {archive ? "Resolved On" : "Status"}
                              </TableCell>
                              <TableCell component="th">View</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {isSuccess &&
                              messages?.data?.data.map((item, index) => {
                                if (
                                  status === 0 &&
                                  item?.initiated?.name ===
                                    item?.last_message?.sender?.name
                                ) {
                                  return "";
                                } else if (
                                  status === 2 &&
                                  item?.initiated?.name !==
                                    item?.last_message?.sender?.name
                                ) {
                                  return "";
                                } else if (status === 2 && item?.status) {
                                  return "";
                                }
                                return (
                                  <>
                                    {" "}
                                    <TableRow key={index}>
                                      <TableCell
                                        component="td"
                                        scope="row"
                                        className={styles.id_table}
                                      >
                                        <Box className={styles.table_id_captns}>
                                          <Link to="">{item?.video?.id}</Link>

                                          {/* <Typography
                                            variant="caption"
                                            className={styles.tooltips_spn}
                                          >
                                            Open Video Page
                                          </Typography> */}
                                        </Box>
                                      </TableCell>

                                      <TableCell
                                        component="td"
                                        scope="row"
                                        className={styles.sender_table}
                                      >
                                        {item?.initiated?.name}
                                        <Typography
                                          variant="caption"
                                          className={styles.design_profile}
                                        >
                                          {item?.initiated?.role?.display_name}
                                        </Typography>
                                      </TableCell>

                                      <TableCell
                                        component="td"
                                        scope="row"
                                        className={styles.recipant_nm_table}
                                      >
                                        {item?.recipent?.name}
                                        <Typography
                                          variant="caption"
                                          className={styles.design_profile}
                                        >
                                          {item?.recipent?.role?.display_name}
                                        </Typography>
                                      </TableCell>

                                      <TableCell
                                        component="td"
                                        scope="row"
                                        className={styles.messages_table}
                                      >
                                        {item?.message?.length > 20
                                          ? item?.message?.slice(0, 110) + "..."
                                          : item?.message}
                                      </TableCell>

                                      <TableCell
                                        component="td"
                                        scope="row"
                                        className={styles.creation_date_table}
                                      >
                                        {getUtcDate(item?.created)} <br />{" "}
                                        {getUtcTime(item?.created)}
                                      </TableCell>

                                      <TableCell
                                        component="td"
                                        scope="row"
                                        className={styles.resolve_table_date}
                                      >
                                        {archive ? (
                                          <TableCell
                                            component="td"
                                            scope="row"
                                            className={
                                              styles.resolve_table_date
                                            }
                                          >
                                            {getUtcDate(item?.resolved_at)}{" "}
                                            <br />{" "}
                                            {getUtcTime(item?.resolved_at)}
                                          </TableCell>
                                        ) : (
                                          <Typography
                                            variant="caption"
                                            className={getStatus(item).class}
                                          >
                                            {getStatus(item).name}
                                          </Typography>
                                        )}
                                      </TableCell>

                                      <TableCell
                                        component="td"
                                        scope="row"
                                        className={styles.view_sec_table}
                                      >
                                        <Box
                                          className={styles.eye_icon_tooltip}
                                        >
                                          <Button
                                            className={styles.eye_icon_sec}
                                          >
                                            <Link
                                              to={`/member-partner-dashboard/message/video/${item?.id}`}
                                            >
                                              {" "}
                                              <img src={view_icon} alt="" />
                                            </Link>
                                          </Button>
                                          <Typography
                                            variant="caption"
                                            className={styles.tooltips_spn2}
                                          >
                                            Open Message
                                          </Typography>
                                        </Box>
                                      </TableCell>
                                    </TableRow>
                                  </>
                                );
                              })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </PerfectScrollbar>{" "}
                  </>
                )}
              </Box>
              <Box className={styles.nextprev_btn}>
                <List>
                  <ListItem>
                    <Button
                      className={`${styles.prev_btn} ${styles.cmn_pagination_btn}`}
                      disabled={!paginationData.hasPrevPage}
                      onClick={handlePrevPage}
                    >
                      <Typography variant="caption">
                        <i>
                          <LeftArrow />
                        </i>{" "}
                        Prev
                      </Typography>
                    </Button>
                  </ListItem>

                  <ListItem>
                    <Button
                      className={`${styles.nxt_btn} ${styles.cmn_pagination_btn}`}
                      disabled={!paginationData.hasNextPage}
                      onClick={handleNextPage}
                    >
                      <Typography variant="caption">
                        <i>
                          <RightArrow />
                        </i>{" "}
                        Next
                      </Typography>
                    </Button>
                  </ListItem>
                </List>
              </Box>
            </Box>
          ) : (
            <Box className={styles.team_message_boxes}>
              <i className={styles.icon}>
                <MessageIcon />
              </i>
              <Typography variant="body1">
                You don’t have any team messages at the moment.
              </Typography>
            </Box>
          )}
        </>
      </MemberPartnerDashboardWrapper>
    </>
  );
}

export default PartnerMessage;
